// extracted by mini-css-extract-plugin
module.exports = {"blue":"#125bee","grey":"#34495e"};